import { ref, update, get } from 'firebase/database';
import { auth, rtdb } from '../../../firebase.config';

export const useLandlordSetup = () => {
  const updateLandlord = async (updatedData) => {
    const user = auth.currentUser;
    if (!user) throw new Error('User not authenticated');

    const userRef = ref(rtdb, `landlords/${user.uid}`);
    await update(userRef, updatedData);

    const snapshot = await get(userRef);
    return snapshot.val();
  };

  return { updateLandlord };
};
